import type { PunchFlag } from "../../shared/policy";

/** Flags in plain English for cleaners (the admin labels use words like "geofence"). */
export const FLAG_PLAIN: Record<PunchFlag, string> = {
  outside_fence: "You seemed to be away from the site",
  location_unavailable: "Your location couldn't be checked",
  site_mismatch: "Your location looked like a different site",
  no_qr: "Done without scanning the code",
  offline_sync: "Sent later (no signal at the time)",
  not_assigned: "You're not usually booked at this site",
  late_clock_out: "Sent after your visit was marked as missing a clock-out",
};

export const plainFlags = (flags: PunchFlag[]) => flags.map((f) => FLAG_PLAIN[f] ?? f);

export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] || name;
}

/** The server's limit for a punch note. */
export const MAX_NOTE = 500;

/**
 * The note from "Can't scan" and the note from "Request approval", kept together (the
 * second used to replace the first), trimmed to the server's limit.
 */
export function joinNotes(
  first: string | null | undefined,
  second: string | null | undefined,
): string | null {
  const parts = [first?.trim(), second?.trim()].filter((p): p is string => !!p);
  const unique = parts.filter((p, i) => parts.indexOf(p) === i);
  return unique.length ? unique.join(" — ").slice(0, MAX_NOTE) : null;
}
